import React from 'react';
import { Grid, Typography } from '@mui/material';

const Header = () => {
  return (
    <Grid 
      container 
      spacing={{ xs: 3, sm: 5 }} 
      justifyContent="center"
      sx={{
        paddingTop: { xs: '100px', sm: '120px' },
        paddingBottom: { xs: '50px', sm: '80px' },
        paddingLeft: { xs: '16px', sm: '32px' },
        paddingRight: { xs: '16px', sm: '32px' },
      }}
    >
      <Grid item xs={12}>
        <Typography 
          variant="h2"
          sx={{
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: { xs: '2rem', sm: '3rem' },
            color: '#000.main',
            position: 'relative',
            marginBottom: 4,
            '&::after': {
              content: '""',
              display: 'block',
              width: '50px',
              height: '4px',
              backgroundColor: '#718895', // Cambiado al color del adorno
              margin: '20px auto 0',
              borderRadius: '2px',
            },
          }}
        >
          <span style={{ color: '#2c3636' }}>Diplomados</span>{' '}
          <span style={{ color: '#718895' }}>disponibles</span>
        </Typography>
        <Typography 
          variant="body1"
          sx={{
            textAlign: 'center',
            marginTop: 3,
            fontSize: { xs: '0.875rem', sm: '1rem' },
            color: 'text.secondary',
            maxWidth: '600px',
            margin: '0 auto',
          }}
        >
          Explora nuestra oferta de diplomados diseñados para potenciar tu desarrollo profesional y personal.
        </Typography>
      </Grid>
    </Grid>
  );
}

export default Header;
